import moment from 'moment';
import { Document, SchemaField, FieldDataType, SystemFieldNames } from '../models/document.model';

export class BasicDocumentReader {
  constructor(public document: Document) {}

  public get uId(): string {
    return this.getFieldValue(SystemFieldNames.uId);
  }

  public get summary(): string {
    return this.getFieldValue(SystemFieldNames.summary);
  }

  public get emailSubject(): string {
    return this.getFieldValue(SystemFieldNames.emailSubject);
  }

  public get title(): string {
    return this.getFieldValue(SystemFieldNames.title);
  }

  public get name(): string {
    return this.getFieldValue(SystemFieldNames.name);
  }

  public get content(): string {
    return this.getFieldValue(SystemFieldNames.content);
  }

  public get postedRawValue(): string {
    return this.getFieldValue(SystemFieldNames.posted);
  }

  public get provider(): string {
    return this.getFieldValue(SystemFieldNames.provider);
  }

  public get address(): string {
    return this.getFieldValue(SystemFieldNames.address);
  }

  public get details(): string {
    return this.getFieldValue(SystemFieldNames.details);
  }

  public get dateCreatedRawValue(): string {
    const value = this.getFieldValue(SystemFieldNames.dateCreated);
    return value;
  }

  public get createdBy(): string {
    return this.getFieldValue(SystemFieldNames.createdBy);
  }

  public get dateUpdatedRawValue(): string {
    const value = this.getFieldValue(SystemFieldNames.dateUpdated);
    return value;
  }

  public get updatedBy(): string {
    return this.getFieldValue(SystemFieldNames.updatedBy);
  }

  public get workflowUId(): string {
    return this.getFieldValue(SystemFieldNames.workflowUId);
  }

  public get workflowStepUId(): string {
    return this.getFieldValue(SystemFieldNames.workflowStepUId);
  }

  public get zIndex(): number {
    return this.getFieldValue(SystemFieldNames.zIndex);
  }

  public get borderColor(): string {
    return this.getFieldValue(SystemFieldNames.borderColor);
  }

  public get fillColor(): string {
    return this.getFieldValue(SystemFieldNames.fillColor);
  }

  public get isSelectable(): boolean {
    return this.getFieldValue(SystemFieldNames.isSelectable);
  }

  public getFieldValue(name: string): any {
    const value = this.document?.hasOwnProperty(name) ? this.document[name] : null;
    return value;
  }

  public valueChanged(schemaField: SchemaField, value: any): boolean {
    let sourceValue = this.getFieldValue(schemaField.systemName);
    sourceValue =
      schemaField.dataType == FieldDataType.DateTime ? (sourceValue == null ? null : moment(sourceValue).toISOString()) : sourceValue;
    sourceValue = sourceValue === '' ? null : sourceValue;

    let targetValue = value === undefined ? null : value;
    targetValue =
      schemaField.dataType == FieldDataType.DateTime ? (targetValue == null ? null : moment(targetValue).toISOString()) : targetValue;
    targetValue = targetValue === '' ? null : targetValue;

    return sourceValue !== targetValue;
  }
}
